import React from 'react'
import ReactTooltip from 'react-tooltip'

const ToolTip = () => {
  return (
    <ReactTooltip id='tool-tip' place='bottom' type='dark' effect='solid' />
  )
}

export default ToolTip
